import { useFormik } from 'formik';
import React from "react";
import { usePaystackPayment } from "react-paystack";
import { useLocation, useNavigate } from "react-router-dom";
import { twMerge } from 'tailwind-merge';
import poweredbywhitebg from "../assets/images/powered_by_white_backgrounds.png";
import EventLogo from "../components/EventLogo";
import Header from "../components/Header";
import { button, input, text } from "../constants/tailwind-theme";

const CheckoutPage = (props) => {

    const navigate = useNavigate();
    const { state } = useLocation();
    const { ticketIndex,ticket } = state; // Read values passed on state


    const formik = useFormik({
        initialValues: {
            first_name: null,
            last_name: "",
            email: "",
            phone: "",
            amount: ticket.ticket_cost * 100,
        },

        validate: (values) => {
            const errors = {};
            if (!values.first_name) {
                errors.first_name = "First name is required";
            }
            if (!values.last_name) {
                errors.last_name = "Last name is required";
            }

            if (!values.phone) {
                errors.phone = "Phone is required";
            }

            if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
                errors.email = "Invalid email address. E.g. example@email.com";
            }


            return errors;
        },

        onSubmit: (values) => {
            initializePayment(onSuccess, onClose);

        },
    });

    const config = React.useMemo(() => {
        return {
            // reference: (new Date()).getTime().toString(),
            email: formik.values.email,
            amount: formik.values.amount,
            publicKey: 'pk_live_8eef26f0b31c8ecfb5013ebda3291104a44e2559',
            currency: "GHS",
            metadata: {
                first_name: formik.values.first_name,
                last_name: formik.values.last_name,
                email: formik.values.email,
                phone: formik.values.phone,
                ticket_name: ticket.ticket_name,
                ticket_id: ticketIndex,
            },

        }
    }, [formik.values.email, formik.values.amount, formik.values.phone]);
    const initializePayment = usePaystackPayment(config);

    // on paystack payment success
    const onSuccess = (reference) => {
        // Implementation for whatever you want to do with reference and after success call.
        console.log(reference);
        navigate("/paymentstatus", { state: { ref: reference, email: formik.values.email } })

        // message : "Approved",
        // redirecturl : "?trxref=T905099353242355&reference=T905099353242355",
        // reference : "T905099353242355",
        // status : "success",
        // trans : "2154106002",
        // transaction : "2154106002",
        // trxref : "T905099353242355"
    };

    // on paystack payment cancelled
    const onClose = () => {
        // implementation for  whatever you want to do when the Paystack dialog closed.
        console.log('closed')
    }


    return (
        <div className="h-screen">

            <Header />

            <form onSubmit={formik.handleSubmit} className="flex md:flex-row flex-col w-full h-full bg-secondary-500">

                {/* SUMMARY */}
                <div className="flex flex-col md:w-6/12 w-full  py-16 px-8 md:px-16">


                    <EventLogo />

                    <h1 className={twMerge(`${text.heading1} text-white my-4`)}>Afrobeats Bazaar Festival </h1>

                    <p className={twMerge(`${text.description1} text-white`)}>Saturday, 10th December 2022</p>
                    <p className={twMerge(`${text.description1} text-white `)}>Nubuke Foundation, East Legon</p>

                    <div className="w-full bg-tertiary-300 rounded-md my-4 p-4">
                        <h1 className={`${text.heading1} `}>{ticket.ticket_name}</h1>
                        <div className="flex flex-row justify-between ">
                            <p className={`${text.description1} `}>GHc {ticket.ticket_cost}</p>
                            <p className={`${text.description1}`}>QTY:1</p>
                        </div>

                    </div>

                    {/* <div className="flex flex-row justify-between mb-4">
                        <p className={twMerge(`${text.description1} text-white`)}>Fees & Taxes:</p>
                        <h2 className={twMerge(`${text.description1} text-white`)}>GHc 9.90</h2>
                    </div> */}
                    <div className="flex flex-row justify-between">
                        <p className={twMerge(`${text.heading1} text-white`)}>Total:</p>
                        <p className={twMerge(`${text.heading1} text-white`)}>GHc {ticket.ticket_cost}</p>
                    </div>

                </div>


                {/* CHECKOUT FORM */}
                <div className="flex flex-col items-center md:w-6/12 w-full  bg-tertiary-300 py-16">


                    <div className="flex flex-col space-y-4"  >
                    <a className="self-start" href="/"> <span className={`${text.description1}`}>{"< BACK"}</span></a>
                        <h1 className={twMerge(`${text.heading1}`)} >Check out</h1>
                        <input className={`${input.default}`} id="first_name" name="first_name" onChange={formik.handleChange} value={formik.values.first_name} type={"text"} placeholder="First Name" />

                        <input className={`${input.default}`} id="last_name" name="last_name" onChange={formik.handleChange} value={formik.values.last_name} type={"text"} placeholder="Last Name" />

                        <input className={`${input.default}`} id="email" name="email" onChange={formik.handleChange} value={formik.values.email} type={"email"} placeholder="Email" />

                        <input className={`${input.default}`} id="phone" name="phone" onChange={formik.handleChange} value={formik.values.phone} type={"text"} placeholder="Phone" />

                        <button type="submit" className={twMerge(`${button.default} w-full `)}>
                            <p className={twMerge(`${button.text} text-white`)}>PAY NOW</p>
                        </button>


                        {formik.isValid ? null : <span className="text-red-500">Please provide valid values to continue payment</span>}
                    </div>
                        <img src={poweredbywhitebg} className="h-6 mt-16" alt="" />


                </div>



            </form>
        </div>

    );
};

export default CheckoutPage;
